import { Environment } from "../../types/misc";
import { allLocales, LANGUAGE_COUNTRY } from "./LocaleAndCountryConstants";

export const DEVELOPMENT = "development";
export const PRODUCTION = "production";

export const STAG_WEB_URL = "stag.winzogames.com";
export const LIVE_WEB_URL = "www.winzogames.com";
export const THE_GCOE_DOT_COM = "www.thegcoe.com";

const STAG_WEBSITE_ENV: Environment = {
    baseApiUrl: "https://d3hg9sjweq5e3n.cloudfront.net/",
    langEnv: "cms/lang-stag",
    version:"1",
    baseFolder: "zo-business",
    gtmId: "GTM-W5W9VBNV",
    baseUrl: STAG_WEB_URL,
    supportedLanguages: allLocales,
    defaultLocale: LANGUAGE_COUNTRY.EN_IN,
    shouldIndex: false,
};

const PROD_WEBSITE_ENV: Environment = {
    baseApiUrl: "https://d3g4wmezrjkwkg.cloudfront.net/",
    langEnv: "cms/lang",
    version:"1",
    baseFolder: "zo-business",
    gtmId: "GTM-W5W9VBNV",
    baseUrl: LIVE_WEB_URL,
    supportedLanguages: allLocales,
    defaultLocale: LANGUAGE_COUNTRY.EN_IN,
    shouldIndex: true,
};

export function getWebsiteEnvironment(): Environment {
    if (process.env.NEXT_PUBLIC_ENV === DEVELOPMENT) return STAG_WEBSITE_ENV;

    return PROD_WEBSITE_ENV;
}

export const isDevelopmentEnv = process.env.NEXT_PUBLIC_ENV === "development";
